module.exports = __webpack_public_path__ + "img/diving.b9338d3b.svg";